import styled from 'styled-components';
import { PetalProps } from '../../interfaces';

export const PetalBox = styled.div<PetalProps>`
cursor:pointer;
width:${props => props.stroke ? "6" : props.isMobile ? '4' : '3'}px;
max-height: ${props => props.isMobile ? "35" : '25'}px;
display: flex;
height: ${props => props.isMobile ? "35" : '24'}px;
align-items: self-end;
-webkit-transform: rotate(${props => props.degrees ? props.degrees : 0}deg);
-ms-transform: rotate(${props => props.degrees ? props.degrees : 0}deg);
transform: rotate(${props => props.degrees ? props.degrees : 0}deg);
-webkit-transform-origin: 100% 100%;
-ms-transform-origin: 100% 100%;
transform-origin: 50% 100%;
position: absolute;
/* animation: go-back 5s;


  @keyframes go-back {
   from {
    height: 0;
  }
  to {
    height:100%;

  }
} */
`
export const PetalsContainer = styled.div<PetalProps>`

width: 100%;
height: ${props => props.heigth ? props.heigth * 100 : 3}%;

background: ${props => props.color ? props.color : '#D3D3D3'} 0% 0% no-repeat padding-box;
border-radius: 120px;
position: absolute;
opacity: 0.7;

`